type WarningMessageProps = { text: string };

export const WarningMessage = ({ text }: WarningMessageProps) => {
  return <div className="text-warning-600 text-sm">{text}</div>;
};
